module.exports = __webpack_public_path__ + "8fe491b12454c1cebed451b3dd22dc70.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/cancel-blue.png
// module id = 3025
// module chunks = 0